import { toFormData } from '../../../../Utils';
import { requestMethods } from '../../../../Constants/requestMethods';
import { path } from '../../Paths';
import { requestFactory } from '../../RequestFactory';

export const getGymTvChannels = () => {
    const url = path.create().getGymTvChannels();

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const createGymTvChannel = () => {
    const url = path.create().addGymTvChannel();

    const requestConfig = {
        url,
        method: requestMethods.POST,
    };

    return requestFactory.createRequest(requestConfig);
};

export const getGymTvChannelById = channelId => {
    const url = path.create().getGymTvChannelById(channelId);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const updateGymTvChannel = (channelId, data) => {
    const url = path.create().updateGymTvChannelById(channelId);

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toFormData(data),
    };

    return requestFactory.createRequest(requestConfig);
};

export const deleteGymTvChannel = channelId => {
    const url = path.create().deleteGymTvChannel(channelId);

    const requestConfig = {
        url,
        method: requestMethods.DELETE,
    };

    return requestFactory.createRequest(requestConfig);
};

export const addGymTvChannelItem = (channelId, data) => {
    const url = path.create().addChannelItem(channelId);

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toFormData(data),
    };

    return requestFactory.createRequest(requestConfig);
};

export const updateGymTvChannelItem = (channelId, itemId, itemData) => {
    const url = path.create().updateChannelItem(channelId, itemId);

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toFormData(itemData),
    };

    return requestFactory.createRequest(requestConfig);
};

export const deleteGymTvChannelItem = (channelId, itemId) => {
    const url = path.create().deleteChannelItem(channelId, itemId);

    const requestConfig = {
        url,
        method: requestMethods.DELETE,
    };

    return requestFactory.createRequest(requestConfig);
};

export const duplicateGymTvChannel = channelId => {
    const url = path.create().duplicateGymTvChannel(channelId);

    const requestConfig = {
        url,
        method: requestMethods.POST,
    };

    return requestFactory.createRequest(requestConfig);
};

export const getGymTvClassesByRoomNumber = roomNumber => {
    const url = path.create().getGymTvClassesByRoomNumber(roomNumber);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/API/GymTvApi/gymTvRequestConfigs.js